var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.shouldBeVisible)?_c('wizard',{staticClass:"onboarding",attrs:{"steps":_vm.wizardSteps,"fullscreenOnMobile":""},on:{"close":_vm.finishOnboarding}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }